export default __webpack_public_path__ + "static/media/import-client-visit-help.60fa48e3.png";